import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Experience from './components/Experience';
import Education from './components/Education';
import Volunteering from './components/Volunteering';
import Project from './components/Project';
import Contact from './components/Contact';
import Research from './components/Research';
import ProjectDetail from './components/ProjectDetail';
import TestimonialForm from './components/TestimonialForm';
import AdminDashboard from './components/AdminDashboard';
import Testimonials from './components/Testimonials';

// Component to conditionally render navbar
function AppContent() {
  const location = useLocation();
  const hideNavbar = location.pathname === '/testimonial';
  
  return (
    <div className="App scroll-smooth">
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={
          <main className="pt-32 md:pt-28">
            <Hero />
            <Testimonials />
            <Experience />
            <Education />
            <Volunteering />
            <Project />
            <Research />
            
            <Contact />
          </main>
        } />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/testimonial" element={<TestimonialForm />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </div>
  );
}

function App() {
  console.log("✅ App.js is mounted and running");

  // ✅ Optional: Keep this if you still want to log visitor IPs
  useEffect(() => {
    console.log("📍 useEffect - logging visitor IP from client");
    async function logVisitor() {
      try {
        const ipRes = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipRes.json();
        const ip = ipData.ip;

        console.log("🌐 Visitor IP:", ip);

        await fetch('/api/log-visit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ ip }),
        });

        console.log("📍 Visitor location sent to Slack");
      } catch (err) {
        console.error("❌ Error logging visitor:", err);
      }
    }
    logVisitor();
  }, []);

  return (
    <Router>
      <AppContent />
      {/* <FloatingChatbot /> Global floating chat - Hidden */}
    </Router>
  );
}

export default App;
